import { SxProps, Theme } from "@mui/material/styles";

export const hsvDividerContainer: SxProps<Theme> = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    px: 2,
};

export const hsvDividerLine: SxProps<Theme> = {
    flex: 1,
    height: "2px",
    backgroundColor: "rgba(255, 255, 255, 0.75)",
};

export const dividerContent: SxProps<Theme> = {
    mx: 3,
    userSelect: "none",
};
